import { parse } from "semver";

/**
 * 全局函数
 * 声明方法:	Vue.prototype.fun = function(){}
 * 组件中调用方法：this.fun()
 **/
export default {
	install(Vue, options) {
		/**web 桌面消息通知（只支持https）
			 * msg:具体描述内容 head:头部内容 type:1是访客接入通知图标，2是消息通知图标
			 * head:title提示内容
			 * 如果不支持https的话会采用网页右下角弹窗方式
			 **/
		Vue.prototype.createWebTips = function (msg, head, type) {
			let closeTime = JSON.parse(LocalStorage.getItem('agentInt')).msgTipTimeLong //消息通知关闭时间 - 秒
			if (closeTime) {
				closeTime = closeTime * 1000
			} else {
				closeTime = 30000 //默认30秒关闭
			}
			//提示声音
			let audio = new Audio()
			audio.src = './static/audio/audioMsg.mp3'
			audio.play()
			audio = null
			if ("https:" == document.location.protocol) {
				// 如果支持window.Notification 并且 许可不是拒绝状态
				if (window.Notification && Notification.permission !== "denied") {
					Notification.requestPermission(function (permission) {
						let notification = new Notification(head, {
							body: msg, //通知内容字符串
							icon: type == 1 ? "/static/images/warning2.png" : "/static/images/icon-audio.png",
							dir: 'auto', //文字方向
							requireInteraction: true, //不自动关闭
							tag: parseInt(Math.random() * 100000), //标识
							renotify: false //新通知是否替换旧通知
						});

						setTimeout(function () {
							notification.close();// 关闭桌面通知
						}, closeTime);
					});
				}
			} else {
				this.$notify({
					title: head,
					message: msg,
					position: 'bottom-right',
					iconClass: type == 1 ? "warning2" : "icon-audio",
					duration: closeTime,//自动关闭时间
				});
			}
		};

		//从菜单集合中获取指定的菜单列表，方便后续执行打开tab页
		Vue.prototype.getMenuItem = function (data, key) {
			let result = null;
			if (!data) {
				return;
			}
			for (let i in data) {
				if (result !== null) {
					break
				}
				let item = data[i];
				//通过url或者菜单名来匹配
				if (item.webUrl == key || item.menuName == key) {
					result = item;
					break;
				} else if (item.children && item.children.length > 0) {
					result = this.getMenuItem(item.children, key);
				} else if (item.menuList && item.menuList.length > 0) {
					result = this.getMenuItem(item.menuList, key);
				}
			}
			return result;
		}

		Vue.prototype.clearLRtrim = function (s) {//去掉前后空格
			return s.replace(/(^\s*)|(\s*$)/g, "");
		}

		/**
			**获取当前年月日。传参（天）返回指定前/后日期（回显普通年月日）
		*/
		Vue.prototype.getWeekTime = function (num) {
			var date1 = new Date();
			if (num) {
				date1.setDate(date1.getDate() + num);
			}
			var seperator1 = "-"
			var year = date1.getFullYear();
			var month = date1.getMonth() + 1;
			var strDate = date1.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			var currentdate = year + seperator1 + month + seperator1 + strDate;

			return currentdate;
		}

		/**
			**获取日期 默认尾部添加时间(00:00:00或者23:59:59)
		**/
		Vue.prototype.getDateFormatYMD = function (val, type) {
			if (val != null) {
				var date = new Date(val);
				var Y = date.getFullYear()
				var M = (date.getMonth() + 1)
				let D = date.getDate()
				M = M < 10 ? '0' + M : M
				D = D < 10 ? '0' + D : D
				let returnDate = ''
				if (type) returnDate = Y + "-" + M + "-" + D + ' 23:59:59'
				else returnDate = Y + "-" + M + "-" + D + ' 00:00:00'
				return returnDate
			}
		}

		/**
			**获取指定年月日时分秒（回显特殊时间用）
		**/
		Vue.prototype.getYMDHMS = function (num) {
			var date1 = new Date();
			if (num) {
				date1.setDate(date1.getDate() + num);
			}
			var seperator1 = "/"
			var year = date1.getFullYear();
			var month = date1.getMonth() + 1;
			var strDate = date1.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			var currentdate = '';
			if (num) {
				currentdate = year + seperator1 + month + seperator1 + strDate + ' 00:00:00';
			} else {
				currentdate = year + seperator1 + month + seperator1 + strDate + ' 23:59:59';
			}
			return currentdate;
		}

		/**
			**获取两个时间相差的天数
		**/
		Vue.prototype.getDaysBetween = function (start, end) {
			const startDate = Date.parse(start);
			const endDate = Date.parse(end);
			const days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000) - 1;
			// alert(days);
			return parseInt(days)
		}

		/**
			** 从树列表获取指定ID的对象
			@ data: 树列表数据
			@ id： 需要对比的id字符串
			@ name: 属性名
		**/
		Vue.prototype.getObjByTree = function (data, id, name) {
			let result = null
			if (!data) return // return; 中断执行
			for (let i in data) {
				if (result !== null) break
				let item = data[i];
				if (item[name] === id) {
					result = item;
					break;
				} else if (item.children && item.children.length > 0) {
					result = this.getObjByTree(item.children, id, name);
				}
			}
			return result;
		}

		/**
			** 秒数转时分秒格式 00:00:00
			@ second: 
		**/
		Vue.prototype.getSecondToTimeString = function (secondNum) {
			if ((secondNum == undefined) || (secondNum == null))
				return "";
			secondNum = parseInt(secondNum);
			if (isNaN(secondNum))
				return "";
			let iHour = Math.floor(secondNum / 3600);
			let iMinute = Math.floor((secondNum - (iHour * 3600)) / 60);
			let iSecond = secondNum - (iHour * 3600) - (iMinute * 60);
			let strHour = String(iHour);
			let strMinute = String(iMinute);
			let strSecond = String(iSecond);
			if (iHour < 10) strHour = "0" + strHour;
			if (iMinute < 10) strMinute = "0" + strMinute;
			if (iSecond < 10) strSecond = "0" + strSecond;
			return strHour + ":" + strMinute + ":" + strSecond;
		}

		// 防止重复点击
		Vue.directive('preventReClick', {
			inserted(el, binding) {
				el.addEventListener('click', () => {
					if (!el.disabled) {
						el.disabled = true
						el.classList.add("is-disabled")
						setTimeout(() => {
							el.disabled = false
							el.classList.remove("is-disabled")
						}, binding.value || 2000)
					}
				})
			}
		})

		Vue.prototype.getZtreeData = function (data, obj) {
			let result = null
			if (!data) return // return; 中断执行
			for (let i in data) {
				if (result !== null) break
				let item = data[i];
				if (item.parentId === obj.parentId) {
					result = data
					break;
				} else if (item.children && item.children.length > 0) {
					result = this.getZtreeData(item.children, obj);
				}
			}
			return result;
		}

		/**
			** 去重
		**/
		Vue.prototype.distinct = function (arr, o) {
			var i, j,
				len = arr.length;
			for (i = 0; i < len; i++) {
				for (j = i + 1; j < len; j++) {
					if (arr[i][o] == arr[j][o]) {
						arr.splice(j, 1);
						len--;
						j--;
					}
				}
			}
			return arr;
		}

		/**
			** 生成32位数
		**/
		Vue.prototype.UUID = function () {
			let len = 32;
			let chars = 'abcdefghijklmnopqrstuvwxyz12345678';
			let maxPos = chars.length;
			let uuid = '';
			for (let i = 0; i < len; i++) {
				uuid += chars.charAt(Math.floor(Math.random() * maxPos))
			}
			return uuid
		}

		/**
		 * 检查iframe子页面加载情况
		 */
		Vue.prototype.iframeIsLoad = function (iframe, callback) {
			if (iframe.attachEvent) {
				console.log('iframe.attachEvent')
				iframe.attachEvent('onload', function () {
					if (callback) {
						callback()
					}
				});
			} else {
				console.log('iframe.onload')
				iframe.onload = function () {
					if (callback) {
						callback()
					}
				}

			}
		}

		/**
		 * 权限配置到全局变量
		 * is_1000配置权限 | is_1001发布权限 | is_1002审批权限 | is_1003查看权限
		 * is_1010短信权限
		 * is_1020邮件权限
		 * is_1030号码隐藏权限 | is_1031号码替换权限
		 * is_1040文书时长编辑 | is_1041小休时长编辑 | is_1042消息提示时长编辑 | is_1043会话上限数编辑 | is_1044热线状态编辑 | is_1045在线状态编辑
		 * is_1050用户扩展信息-通话控制配置 | is_1051用户扩展信息-电话坐席配置 | is_1052用户初始信息批量处理 | is_1053用户扩展通话信息批量处理
		 */
		Vue.prototype.powerListSet = function () {
			this.GLOBAL.power = {}
			let powerList = SessionStorage.getItem('powerList')
			if (powerList) {
				powerList = JSON.parse(powerList)
				for (let i = 0; i < powerList.length; i++) {
					if (powerList[i].pValue) {
						this.$set(this.GLOBAL.power, 'is_' + powerList[i].pValue, true)
					}
				}
				console.log(this.GLOBAL.power)
			}
		}

		/**
		 * 隐藏号码
		 */
		Vue.prototype.hidePhoneNum = function (phone) {
			let rePhone = ''
			phone = phone + ''
			if (phone && phone.length > 3) {
				let one = Math.floor((phone.length - 4) / 2)
				let two = Math.ceil((phone.length - 4) / 2)
				let reg = "^(\\d{" + one + "})\\d{4}(\\d{" + two + "})$"
				reg = new RegExp(reg)
				rePhone = phone.replace(reg, '$1****$2')
			}
			return rePhone
		}

		/**
		 * 隐藏号码All
		 */
		 Vue.prototype.hidePhoneNumAll = function (phone) {
			let rePhone = ''
			phone = phone + ''
			if (phone) {
				for (var i=0;i<phone.length;i++) {
					rePhone += '*'
				}
			}
			return rePhone
		}

		/**
		 * 标题闪烁
		 */
		Vue.prototype.titleSF = function () {
			if (this.$store.state.navTabs.activeTabName != '777') {
				//当前的tab页面不是线上客服时，要让线上客服的标题闪烁
				$('#tab-777').addClass('title_zx')
				setTimeout(() => {
					this.titleSF()
				}, 300)
			}
		}
		/**
		 * 浏览器标题栏模拟闪烁
		 */
		Vue.prototype.bowserTitleSF = function () {
			let path = '';
			if(window.projectConfig && window.projectConfig.logoPathName){
				path = '_' + window.projectConfig.logoPathName;
			}
			if (this.GLOBAL.FOCUSPAGE !== 1) {
				//页面非激活状态
				if (document.title == '.' || document.title == '呼叫中心' || document.title == window._CONFIG.title) {
					document.title = '你有新的线上信息'
					document.getElementById('shortcutIcon').href = './static/images/warning2.png'
				} else {
					document.title = '.'
					document.getElementById('shortcutIcon').href = './static/images'+ path +'/favicon.ico'
				}
				this.GLOBAL.TIME_1 = setTimeout(() => {
					this.bowserTitleSF()
				}, 500)
			} else {
				document.title = window._CONFIG.title?window._CONFIG.title:'呼叫中心'
				document.getElementById('shortcutIcon').href = './static/images'+ path +'/favicon.ico'
				this.GLOBAL.TIME_1 = null
			}
		}

		/**
		 * 校验手机号是否正确
		 */
		Vue.prototype.checkMobile = function(tel){
			return /(^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$)|(^[2-9]\d{7})/.test(tel); //只校验手机
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/Common/base.js